const Colors = {
  basic: {
    black: '#000000',
    white: '#FFFFFF',
  },
  primary: {
    main: '#253746',
    secondary: '#40C1AC',
    yellow: '#FFB81C',
    red: '#EE2737',
    gray: '#838383',
    background: '#F5F7F9',
    infoBackground: '#F0F3F6',
  },
  error: {
    main: '#FF0000',
  },
  slider: {
    full: '#686868',
  },
}

export default Colors
